import * as Yup from 'yup'

export const Password = Yup.string()
  .required('Required')
  .matches(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/, 'Invalid Password')

export const CVV = (maxLength: number) =>
  Yup.string()
    .required('Required')
    .min(3, 'Minimum 3 digits required')
    .max(maxLength, `Maximum ${maxLength} digits allowed`)
    .matches(/^[0-9]+$/)
    .test('Test if its a valid', `Maximum ${maxLength} digits allowed`, (value: string) => {
      if (!value) {
        return false
      } else {
        return true
      }
    })

export const OTP = Yup.string().required('Required').min(6, '').max(6, 'OTP should be 6 digits long')

export const TwoInputSchema = (field1: string, field2: string, cvvMaxLength: number) =>
  Yup.string()
    .required('Required')
    .test('Test if its a valid', `Enter both ${field1} and ${field2}`, async (value: any) => {
      const splitValues = value.split('_')
      console.log('va', splitValues[0])
      const expDateSchema = Yup.string()
        .required('Required')
        .min(4, 'Enter valid 4 digits')
        .required('Required')
        .matches(/^[0-1][0-9]\/[0-9][0-9]$/, 'Invalid Date (mm/yy). Starting digit must be 0 or 1 eg: 09/19')
        .test('Test if its a valid', 'Month should be less than or equal to 12 and greater than 0', (value: string) => {
          if (!value) {
            return false
          }
          const monthStr = value.split('/')[0]
          const month = Number(monthStr)
          if (isNaN(month)) {
            return false
          }
          const ret = month < 13 && month > 0
          return ret
        })
        .test('Test if its a future date', 'Expiry date should be future date', (value: string) => {
          if (!value) {
            return false
          }
          const monthStr = value.split('/')[0]
          const yearStr = value.split('/')[1]
          if (!monthStr || !yearStr) {
            return false
          }
          const month = Number(monthStr)
          const year = Number(`20${yearStr}`)
          if (isNaN(month) || isNaN(year)) {
            return false
          }
          const today = new Date()
          return year > today.getFullYear() || (year === today.getFullYear() && month >= today.getMonth() + 1)
        })
        .test('Test if its a future date', 'Expiry date should be less than 10 years', (value: string) => {
          if (!value) {
            return false
          }
          const yearStr = value.split('/')[1]
          if (!yearStr) {
            return false
          }
          const year = Number(`20${yearStr}`)
          if (isNaN(year)) {
            return false
          }
          const today = new Date()
          const MAX_EXPIRY_YEARS = 10
          return today.getFullYear() + MAX_EXPIRY_YEARS > year ? true : false
        })
      const isExpValid = await expDateSchema.isValid(splitValues[0])

      const cvvSchema = Yup.string()
        .required('Required')
        .min(3, 'Enter valid 3 digits')
        .matches(/^[0-9]+$/, 'Enter Valid CVV')
        .max(cvvMaxLength, `Enter valid ${cvvMaxLength} digits`)
        .required('Required')

      const isCVVValid = await cvvSchema.isValid(splitValues[1])

      return isExpValid && isCVVValid
    })

export const UPI = Yup.string()
  .required('Required')
  .matches(/^[\w\.\-_]{3,}@[a-zA-Z]{3,}/, 'Enter Valid VPA')
  .test(
    'Test if its a valid',
    `Invalid VPA.
Provide a valid VPA.`,
    (value: string) => {
      return /^[\w\.\-_]{3,}@[a-zA-Z]{3,}/.test(value)
    },
  )

export const vpaOrNumber = Yup.string()
  .required('Required')
  .test('Test is it valid mobile number', 'Invalid VPA / Number', (value: string) => {
    let isValid = false
    if (value && (/^\d{8,15}$/.test(value) || /^[\w\.\-_]{3,}@[a-zA-Z]{2,}/.test(value))) {
      isValid = true
    }
    return isValid
  })
export const Name = Yup.string()
  .min(2, 'Too Short!')
  .max(60, 'Too Long!')
  .required('Required')
  .matches(/^[a-zA-Z ]+$/, 'Invalid Name')

export const CheckBoxsSchema = Yup.string().required('The terms and conditions must be accepted.')
